
import { FacturacionCPEService } from './../../services/facturacion-cpe/facturacion-cpe.service';
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';
import Swal from "sweetalert2";

@Component({
  selector: 'app-nota-credito',
  templateUrl: './nota-credito.component.html',
  styleUrls: ['./nota-credito.component.scss']
})
export class NotaCreditoComponent {

  constructor(private router:Router,private loginService:LoginService,private cpeService :FacturacionCPEService) { }

  clickGuard(){
    this.loginService.clickGuard = true;
  }
  clickGuard2(){
    if(this.cpeService.TipoCambio.length > 0){
       this.loginService.clickGuard = true;
    }else{
      Swal.fire({
        title: "¡Algo salió mal!",
        text:  "Se requiere tipo de cambio ",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false 
    });
      this.goBack();
    }
 }
 goBack(){
  this.loginService.clickGuard = true;
  this.router.navigate(['/facturacion/notaCredito/listado']);
 }

}
